import { useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Briefcase, UserCircle, Users, Menu, Plus, Receipt, Camera } from "lucide-react";

const left = [
  { to: "/app", label: "Home", icon: LayoutDashboard, end: true, testid: "bottom-nav-overview" },
  { to: "/app/jobs", label: "Jobs", icon: Briefcase, testid: "bottom-nav-jobs" },
];
const right = [
  { to: "/app/customers", label: "Customers", icon: UserCircle, testid: "bottom-nav-customers" },
];
const quickItems = [
  { to: "/app/leads", label: "Lead", icon: Users, testid: "quick-add-lead" },
  { to: "/app/jobs", label: "Job", icon: Briefcase, testid: "quick-add-job" },
  { to: "/app/expenses", label: "Expense", icon: Receipt, testid: "quick-add-expense" },
];

const cls = (active) =>
  `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] transition-colors ${
    active ? "text-[#FF5A00]" : "text-zinc-500 hover:text-zinc-900"
  }`;

const NavItems = ({ items }) =>
  items.map(({ to, label, icon: Icon, end, testid }) => (
    <NavLink key={testid} to={to} end={end} data-testid={testid} className={({ isActive }) => cls(isActive)}>
      <Icon className="w-5 h-5" />
      <span>{label}</span>
    </NavLink>
  ));

const QuickAdd = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const camRef = useRef(null);
  const go = (to) => { setOpen(false); navigate(to); };
  const onSnap = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (file) navigate("/app/expenses", { state: { snapFile: file } });
  };
  return (
    <div className="flex-1 flex justify-center relative">
      <input ref={camRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={onSnap} data-testid="quick-add-snap-input" />
      {open && <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} data-testid="quick-add-backdrop" />}
      {open && (
        <div className="absolute bottom-16 z-40 w-48 bg-white border border-zinc-200 rounded-xl shadow-xl p-1.5" data-testid="quick-add-menu">
          <button type="button" onClick={() => { setOpen(false); camRef.current?.click(); }} data-testid="quick-add-snap-receipt"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-zinc-800 hover:bg-orange-50 transition-colors">
            <Camera className="w-4 h-4 text-[#FF5A00]" />
            <span>Snap receipt</span>
          </button>
          {quickItems.map(({ to, label, icon: Icon, testid }) => (
            <button key={testid} type="button" onClick={() => go(to)} data-testid={testid}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-zinc-800 hover:bg-orange-50 transition-colors">
              <Icon className="w-4 h-4 text-[#FF5A00]" />
              <span>New {label.toLowerCase()}</span>
            </button>
          ))}
        </div>
      )}
      <button type="button" onClick={() => setOpen((o) => !o)} aria-label="Quick add" data-testid="bottom-nav-quick-add"
        className="relative z-40 -mt-5 w-14 h-14 rounded-full bg-[#FF5A00] hover:bg-[#E04F00] text-white shadow-lg flex items-center justify-center ring-4 ring-white transition-transform active:scale-95">
        <Plus className={`w-6 h-6 transition-transform ${open ? "rotate-45" : ""}`} strokeWidth={2.5} />
      </button>
    </div>
  );
};

export const MobileBottomNav = ({ onMore }) => (
  <nav
    className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-zinc-200 flex items-center pb-[env(safe-area-inset-bottom)]"
    data-testid="mobile-bottom-nav"
  >
    <NavItems items={left} />
    <QuickAdd />
    <NavItems items={right} />
    <button type="button" onClick={onMore} className={cls(false)} data-testid="bottom-nav-more">
      <Menu className="w-5 h-5" />
      <span>More</span>
    </button>
  </nav>
);
